import React from 'react'
import { useGeoState } from '../GeoProvider'
import moment from 'moment'
import styles from './DisplayDateNew.module.scss'
import getEpiWeek from '../../utils/getEpiWeek'
import toTitleCase from '../../utils/toTitleCase'
export const DisplayDateFluNew = ({
  statesData,
  showWeek,
  diseaseType,
}) => {
  
  
  const {  displayDate, indicatorName } = useGeoState()
  const disease =  (diseaseType === 'covid')  ? 'COVID-19' : (diseaseType === 'rsv') ? 'RSV'  : toTitleCase(diseaseType)
  // TODO : this const number should be moved out at the /Flu level to be used also for the <DisplayDate /> component
   

  // TODO: can break this into a common function for the display date and this component to use!
  const keys = Object.keys(statesData).sort()
  const values = Object.values(statesData)
  const daysData = values.map((weeklyData, index) => {
    return { index, date: keys[index], ...weeklyData }
  })
  const epiweek = (daysData.filter((w) => w.date === displayDate)[0].TX.epiweek!==undefined?daysData.filter((w) => w.date === displayDate)[0].TX.epiweek:'')
  return (
    <div className={styles.base}>
      <div className={styles.dateWeek}>
        {indicatorName.toUpperCase()==='ACTUALS'?
        <p className={styles.displayDateMargin}>
          {disease} Levels - {indicatorName} for {' '}
          {showWeek ? ` Epiweek ${epiweek}: ` : null}
          {moment(displayDate).format('MMMM D, YYYY')}{' '}
        </p>
        :<p className={styles.displayDateMargin}>
         {disease} Levels - {' '}
        {showWeek ? ` Epiweek ${epiweek}: ` : null}
        {moment(displayDate).format('MMMM D, YYYY')}{' '}
      </p>}
      </div>
    </div>
  )
}

export default DisplayDateFluNew
